/* jshint esversion: 6 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes.js';

Vue.use(VueRouter);

const router = new VueRouter({
    routes: routes,
  // esto hay que atarlo a si estoy en cordova o no
    mode: process.env.HISTORY_MODE,
    base: process.env.ROUTE_BASE
});

router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.title) {
        document.title = to.meta.title;
        if (process.env.APP_NAME) {
            document.title += ' - ' + process.env.APP_NAME;
        }
    } else {
        if (process.env.APP_NAME) {
            document.title = process.env.APP_NAME;
        }
    }
    next();
});

router.rememberRoute = null;

router.stack = [];
router._push = router.push;
router._replace = router.replace;
router._go = router.go;

router.rememberBack = function () {
    if (router.rememberRoute) {
        router.push(router.rememberRoute);
        router.rememberRoute = null;
    } else {
        router.replace({name: HOME_DIR});
    }
};

router.push = function (data) {
    if (data.name !== HOME_DIR) {
        router.stack.push(data);
    } else {
        router.stack = [];
    }
    router._push(data);
};

router.replace = function (data) {
    if (data.name !== HOME_DIR) {
        router.stack.pop();
        router.stack.push(data);
    } else {
        router.stack = [];
    }
    router._push(data);
};

router.go = function (number) {
    router.stack.splice(-1, -number);
    router._go(number);
};

export default router;

export const HOME_DIR = 'home';
export const LOGIN_DIR = 'login';



// WEBPACK FOOTER //
// ./src/router/index.js